import { SceneContext } from 'konva/lib/Context'
export const calcClipFuncAvatar = (ctx: SceneContext, x: number, y: number, radius: number) => {
    ctx.arc(x, y, radius, 0, Math.PI * 2, false)
}
